var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel', 'save'],"loading":_vm.loading,"large":"","title":"Novo lote"},on:{"save":function($event){return _vm.$refs.Form.handleSave()}}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data},on:{"save":function($event){return _vm.$emit('save', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }